module.exports = __webpack_public_path__ + "img/com-cbam.a74574ea.png";